module.exports = __webpack_public_path__ + "a2ccf6670a57af56c6da7c5f04e82689.svg";